import { useState } from 'react';
import { Redirect, useLocalSearchParams, useRootNavigationState } from 'expo-router';
import { StyleSheet } from 'react-native';

import { View, Text } from '@/components/Themed';
import { useUser } from './user-context';
import { useAuthCallback } from '@/hooks/useAuthCallback';
import { useI18n } from '@/i18n';

export default function Callback() {
  const { code, state } = useLocalSearchParams<{ code?: string; state?: string }>();
  const navState = useRootNavigationState();
  const isNavigationReady = !!navState?.key;
  const { user, setUser } = useUser();
  const { t } = useI18n();
  const [error, setError] = useState<string | null>(null);
  const { loading } = useAuthCallback({ code, state, user, setUser, onError: setError });

  if (!isNavigationReady) {
    return null;
  }

  if (user) {
    return <Redirect href="/welcome" />;
  }

  return (
    <View style={styles.container}>
      <Text style={styles.message}>{loading ? t('auth.callbackLoading') : t('auth.callbackReady')}</Text>
      {error ? <Text style={styles.error}>{error}</Text> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
  },
  message: {
    color: '#C8C8B0',
  },
  error: {
    color: '#ff7b7b',
  },
});
